enum DataSourceType {
    sfdc = 'Salesforce',
    svmx = 'ServiceMax',
    custom = 'Custom',
    sap = 'SAP',
    dynamics = 'Dynamics',
    davisware = 'Davisware',
    servicenow = 'ServiceNow',
    csv = 'Csv',
    oracle = 'Oracle',
}

export default DataSourceType;
